import { ReactElement } from 'react'
import styled from 'styled-components'

import { IIconProps } from './types'

const Svg = styled.svg`
  fill: #916ee8;
  height: 24px;
  width: 24px;
`
export const ArrowRightIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
      <path d="M17.55 16.4742L16.475 15.4242L19.125 12.7742H3V11.2742H19.15L16.5 8.62422L17.55 7.57422L22 12.0242L17.55 16.4742Z" />
    </Svg>
  )
}
